export default __webpack_public_path__ + "static/media/2218.72817296.png";